import { Card, CardActionArea, CardContent, CardMedia } from "@mui/material";
import React from "react";
import { StudioData } from "../../Objects/StudioInterface";
import StudioName from "../atoms/StudioName";

export interface StudioCardProps {
    studioData: StudioData
    onClick?: (studioData: StudioData) => void | undefined
    footMenu?: React.ReactNode
}

const StudioCard: React.FC<StudioCardProps> = ({
    studioData,
    onClick,
    footMenu
}) => {
    let content = (
        <>
            <CardMedia
                component="img"
                height={150}
                src={process.env.REACT_APP_API_ENDPOINT + `img/studio/${studioData.stdimg_id}`}
            />
            <CardContent>
                <StudioName
                    studioData={studioData}
                    showId
                />
            </CardContent>
        </>
    )

    return (
        <Card variant="outlined">
            {onClick ? (
                <CardActionArea
                    onClick={() => {
                        if (onClick) {
                            onClick(studioData)
                        }
                    }}
                >{content}</CardActionArea>
            ) : (content)}
            {footMenu}
        </Card>
    )
}

export default StudioCard